import PropTypes from 'prop-types';
import React from 'react';

import {Modal} from '@albert-io/atomic';
import ResetPassword from 'client/components/ResetPassword/ResetPassword';

import {resource} from '@albert-io/json-api-framework/request/builder';
import {genericMandarkRequest} from 'resources/mandark.resource';
import {getModelForResourceType} from 'resources/modelRegistry';

/**
 * ResetPasswordModal
 *
 * **This component is not to be confused with ChangePasswordModal**
 *
 * It appears whereever teachers and administrators have the ability
 * to reset the passwords of managed account holders.
 *
 * It returns an instance of a ResetPassword component with the necessary
 * submit and submit callback props--in this case, for initiating a request
 * to /managed_users_v1 and returning a Promise, then closing the modal on
 * successful resolution.
 *
 */

function makeResetPasswordRequest({userId, value}) {
  const query = resource('managed_user_v1').mandarkEndpoint(['managed_users_v1', userId]).done();
  return genericMandarkRequest('patch', query, {
    data: {
      attributes: {
        password: value
      }
    }
  });
}

export default class ResetPasswordModal extends React.Component {
  static propTypes = {
    handleClose: PropTypes.func,
    student: PropTypes.instanceOf(getModelForResourceType('student_v2')).isRequired
  };

  static defaultProps = {
    handleClose: () => {}
  };

  handleSubmit = async (value) => {
    await makeResetPasswordRequest({
      userId: this.props.student.getId(),
      value
    });
  };

  render() {
    const {handleClose, student} = this.props;
    const ariaLabel = `Reset password for ${student.getFullName()}`;
    return (
      <Modal ariaLabel={ariaLabel} handleClose={handleClose}>
        {({modalContentStyle}) => {
          return (
            <ResetPassword
              className={modalContentStyle}
              handleClose={handleClose}
              onCancel={handleClose}
              onSubmitSuccess={handleClose}
              inModal
              onSubmit={this.handleSubmit}
              title={ariaLabel}
            >
              <ResetPassword.Legend>{`${student.getFullName()} (${student.getEmail()})`}</ResetPassword.Legend>
              <ResetPassword.Form>
                <ResetPassword.NewPasswordField />
                <ResetPassword.ConfirmPasswordField />
                <ResetPassword.ShowPasswordToggle />
              </ResetPassword.Form>
            </ResetPassword>
          );
        }}
      </Modal>
    );
  }
}
